import { Button } from '@pets-ui/Button/Button'
import { createSvgIcon } from '@pets-ui/Logos/createSvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useHistory } from 'react-router-dom-v5'
import CartEmptySvg from '../../assets/fastpass-empty-cart.svg?react'

const CartEmptyIcon = createSvgIcon(CartEmptySvg)

interface CartEmptyProps {
  environment: 'campaign' | 'merchant'
  campaignCode?: string
}

export function CartEmpty(props: CartEmptyProps) {
  const { environment, campaignCode } = props
  const history = useHistory()

  const handleClick = () => {
    if (!campaignCode) return
    if (environment === 'campaign') {
      history.push(`/campaigns/${campaignCode}`)
    }
    if (environment === 'merchant') {
      history.push(`/merchant/${campaignCode}/product-catalog`)
    }
  }
  return (
    <VStack gap={5} minHeight="inherit" alignItems="center" justifyContent="center">
      <CartEmptyIcon fontSize={160} />
      <Text variant="subtitle">購物車中沒有商品</Text>
      <Button onClick={handleClick}>去選購</Button>
    </VStack>
  )
}
